import styled from "styled-components/macro";

import { fnrLabeledIconVariants } from "./FnrLabeledIcon";

const FnrLabeledIconContainer = styled("div")`
  display: flex;
  word-wrap: break-word;
  ${({
    $variant,
    theme: {
      colors: { textSecondary },
    },
  }) => {
    switch ($variant) {
      case fnrLabeledIconVariants.greyHeader:
        return `
              gap: 20px;
              align-items: center;
              color: ${textSecondary};
              weight: 400;
              font-size: 24px;
          `;
      case fnrLabeledIconVariants.greyHeaderColumn:
        return `
                gap: 16px;
                flex-direction: column;
                font-size: 24px;
                font-weight: 400;
                color: ${textSecondary};
                & div { font-size: 48px; }
            `;
      case fnrLabeledIconVariants.leftColumn:
        return `
              gap: 4px;
              flex-direction: column;
              & div { font-size: 28px; }
          `;
      case fnrLabeledIconVariants.disabled:
        return `
              align-items: center;
              gap: 6px;
              color: ${textSecondary};
              font-size: 15px;
              & div { width: 24px; text-align: center; };
        `;
      case fnrLabeledIconVariants.small:
        return `
              align-items: center;
              gap: 6px;
              font-size: 15px;
              & div { width: 24px; text-align: center; };
              `;
      default:
        return `
              align-items: center;
              gap: 6px;
              & div { font-size: 18px; width: 24px; text-align: center; };
              `;
    }
  }}
`;

export default FnrLabeledIconContainer;
